import styled from "styled-components";
import { FC } from "react";

import { BaseComponentProps } from "../types";
import { BaseIcon } from "./BaseIcon";
import { SizedIcon } from "./SizedIcon";
import { IconSize, SemanticIconName } from "./types";
import "../../designTokens/variables.css";

const semanticIconColors: Record<SemanticIconName, string> = {
  checked: "var(--color-success-500)",
  error: "var(--color-error-500)",
  ["flag-error"]: "var(--color-error-500)",
  ["flag-success"]: "var(--color-success-500)",
  ["flag-warning"]: "var(--color-warning-500)",
  ["heart-off"]: "var(--color-error-500)",
  ["heart-on"]: "var(--color-error-500)",
  information: "var(--color-primary-500)",
  no: "var(--color-error-500)",
  ["star-off"]: "var(--color-warning-500)",
  ["star-on"]: "var(--color-warning-500)",
  success: "var(--color-success-500)",
  warning: "var(--color-warning-500)",
} as const;

type StyledSemanticIconProps = {
  $iconName: SemanticIconProps["iconName"];
};

const StyledSemanticIcon = styled(SizedIcon)<StyledSemanticIconProps>`
  svg {
    --main-color: ${({ $iconName }): string => semanticIconColors[$iconName]};
  }
`;

type SemanticIconProps = BaseComponentProps<
  "svg",
  {
    /** The semantic icon that will be rendered. */
    iconName: SemanticIconName;

    /** The size of icon that will be rendered. */
    iconSize?: IconSize;
  }
>;

export const SemanticIcon: FC<SemanticIconProps> = ({
  iconName,
  iconSize = "regular",
  className,
  ...props
}) => (
  <StyledSemanticIcon
    className={className}
    $iconName={iconName}
    $iconSize={iconSize}
  >
    <BaseIcon iconName={iconName} disabled={false} {...props} />
  </StyledSemanticIcon>
);

// TODO: Remove this component as soon as possible. Use the prop `iconSize` instead.

export const SmallSemanticIcon: FC<SemanticIconProps> = ({
  iconName,
  iconSize = "small",
  className,
  ...props
}) => (
  <StyledSemanticIcon
    className={className}
    $iconName={iconName}
    $iconSize={iconSize}
  >
    <BaseIcon iconName={iconName} disabled={false} {...props} />
  </StyledSemanticIcon>
);
